import * as React from 'react';
import { makeStyles } from '@mui/styles';
import { TextField, Box} from '@mui/material';
import { styled } from '@mui/material/styles';
import moment from 'moment';

const useStyles = makeStyles({
  root: {
    width: '100%',
    '&>:nth-child(1)': {
      backgroundColor: '#F3F5F7',
      padding: 0,
      borderRadius: '50px',
    },
  },
  input: {
    borderRadius: '4px',
    padding: '16px',
    backgroundColor: '#F3F5F7',
    color: '#505F79',
    textAlign: 'left',
    '&:focus': {
      backgroundColor: '#FFFFFF',
    },
  },
  error: {
    backgroundColor: '#FFFFFF',
  },
  helperText: {
    marginLeft: 0,
    fontSize: '12px',
    color: '#FC2C32',
  }
});

const StyledTextField = styled(TextField)(({ error, border }) => ({
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#F3F5F7',
      border: border,
    },
    '&:hover fieldset': {
      borderColor: error ? '#FC2C32' : 'grey',
    },
    '&.Mui-focused fieldset': {
      borderColor: error ? '#FC2C32' : '#092682',
    },
  },
  '& .MuiFormHelperText-root.Mui-error': {
    color: '#FC2C32',
  },
  '& .MuiInputBase-root-MuiOutlinedInput-root.Mui-error.MuiOutlinedInput-notchedOutline':
    {
      borderColor: '#FC2C32',
    },
  '& .MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root': {
    backgroundColor: '#F3F5F7',
  },
  '.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input': {
    textOverflow: 'ellipsis !important',
    maxWidth: '100%',
  },
  '.css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper .css-6hp17o-MuiList-root-MuiMenu-list': {
    overflowX: 'auto !important'
  },
  '.css-k008qs': {
    overflow: 'hidden',
    width: '95%'
  }
}));

export default function KenTextField(props) {
  const {
    FormHelperTextProps,
    InputLabelProps,
    inputProps,
    InputProps,
    className,
    error,
    errorLabel,
    children,
    disableKeyDown,
    minDate,
    maxDate,
    name,
  } = props;

  const classes = useStyles();

  return (
    <>
      <StyledTextField
        className={`${className}`}
        classes={{ root: classes.root }}
        InputLabelProps={{ shrink: false, ...InputLabelProps }}
        inputProps={{
          className: error
            ? `${classes.input} ${classes.error}`
            : classes.input,
          ...inputProps,
        }}
        InputProps={{
          components: 'p',
          inputProps: {
            min:
              minDate &&
              (minDate === true
                ? moment().format('YYYY-MM-DD')
                : moment()
                    .subtract(Number(minDate), 'years')
                    .format('YYYY-MM-DD')),
            max:
              maxDate &&
              (maxDate === true
                ? moment().format('YYYY-MM-DD')
                : moment().add(Number(maxDate), 'years').format('YYYY-MM-DD')),
            'data-testid': `test-${name}`,
          },
          ...InputProps,
        }}
        FormHelperTextProps={{
          className: classes.helperText,
          ...FormHelperTextProps,
        }}
        SelectProps={{
          MenuProps: {
            PaperProps: {
              style: {
                maxHeight: '300px',
                marginTop: '8px',
                boxSizing: 'border-box',
                borderTop: '8px solid #ffffff',
                borderBottom: '8px solid #ffffff',
                overflowX: 'auto'
              },
            },
          },
        }}
        {...props}
        onKeyDown={(e) => {
          disableKeyDown && e.preventDefault();
        }}
        label=""
        error={errorLabel ? errorLabel : error}
        helperText={errorLabel ? null : error}
      >
        {children}
      </StyledTextField>
    </>
  );
}
